import { addMinutes, startOfDay } from 'date-fns';
import { useCallback } from 'react';
import { type DatePickerDateType, getDateType } from 'ui';
import { SLOT_INTERVAL_MINUTES } from './time-slot';

export const useGetStartTimeSlots = () =>
  useCallback(
    (startDate: DatePickerDateType): Date[] =>
      Array.from({ length: (24 * 60) / SLOT_INTERVAL_MINUTES }, (_, index) =>
        addMinutes(startOfDay(getDateType(startDate)), index * SLOT_INTERVAL_MINUTES),
      ),
    [],
  );
